export const adoptQuizKeys = {
  all: ['adopt-quiz'] as const,
  publicShelterLookup: (segment: string) =>
    [...adoptQuizKeys.all, 'publicShelterLookup', segment] as const,
  publicSheltersList: () => [...adoptQuizKeys.all, 'publicSheltersList'] as const,
};
